import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Grid } from '@mui/material';

import {
  GenderField,
  InputField,
  CustomSelectBox
} from 'modules/report/components/report-components/therapeutic-adjustment/calculators';
import { selectboxItems } from 'modules/report/utils/calculators-schema-utils';
import { EGFR_formuls } from 'modules/report/utils/calculators-formuls-utils';

const EGFR = ({ isMale, userAge }) => {
  const [values, setValues] = useState({
    calculatorType: 'CKD-EPI',
    sex: isMale ? 'Male' : isMale === false ? 'Female' : isMale ?? null,
    age: userAge ? userAge : null,
    creatinine: null,
    result: null,
    errors: null,
    submitCount: 0
  });

  const { sex, age, creatinine, result } = values || {};

  const validation = {
    creatinine: creatinine >= 0.1 && creatinine <= 20,
    age: values.calculatorType === 'CKD-EPI' ? age >= 18 : age >= 1
  };

  const resetResult = () => setValues((prev) => ({ ...prev, result: null }));

  const genderHandler = (value) => {
    resetResult();
    setValues((prev) => ({ ...prev, sex: value }));
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    resetResult();
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const calculateHandler = (creatinine, age) => {
    const validations = validation.age && validation.creatinine && sex;

    setValues((prev) => ({ ...prev, submitCount: values.submitCount + 1 }));

    if (validations) {
      const result = EGFR_formuls[values.calculatorType][sex].calc(
        +creatinine,
        +age
      );
      setValues((prev) => ({ ...prev, result }));
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const calcBtnIsActive =
    values.submitCount > 0
      ? validation.age && validation.creatinine && sex
      : sex && age && creatinine && !result;

  return (
    <>
      <Header>
        <CustomSelectBox
          values={values}
          items={selectboxItems}
          name="calculatorType"
          onChange={onChangeHandler}
        />
        <span dir="ltr">Calculation Method :</span>
      </Header>
      <Grid
        dir="ltr"
        container
        xs={12}
        sx={{
          mt: '32px',
          gap: { md: '14px', xs: '20px' },
          flexDirection: 'column'
        }}
      >
        <InputField
          length="3"
          name="creatinine"
          inputmode="decimal"
          label="Serum creatinine (mg/dL)"
          errorText="please enter the corect Cr value (0.1 _ 20 mg/dL). "
          values={values}
          error={!validation.creatinine}
          onChange={onChangeHandler}
        />
        <InputField
          length="2"
          label="Age"
          name="age"
          errorText={
            values.calculatorType !== 'CKD-EPI'
              ? 'please enter the valid age'
              : 'The minimum value for age is 18.'
          }
          values={values}
          error={!validation.age}
          onChange={onChangeHandler}
        />
        <GenderField onClickHandler={genderHandler} value={sex} />
        <CalculateButton
          fullWidth
          disabled={!calcBtnIsActive}
          onClick={() => calculateHandler(creatinine, age)}
        >
          <span>Calculate</span>
        </CalculateButton>
        <Result hasResult={!!result}>
          <p>eGFR (ml/min/1.73m2.):</p>
          <span>{result !== null ? Math.round(result) : '-'}</span>
        </Result>
      </Grid>
    </>
  );
};

const CalculateButton = styled(Button)`
  height: 45px;
  text-transform: unset !important;
  margin: 36px auto 7px !important;
  border-radius: 16px !important;
  background: ${({ disabled }) =>
    !!disabled ? 'transparent !important' : '#753CBE !important'};
  border: ${({ disabled }) =>
    !!disabled ? '1px solid #FFFFFF !important' : 'none !important'};
  font-size: 16px !important;
  font-family: 'dana-bold';
  box-shadow: 1px 1px 2px 0px #00000029 !important;
  span {
    color: ${({ disabled }) =>
      !!disabled ? 'rgba(172, 172, 172, 1)' : '#FFFFFF'};
    text-align: center;
  }

  @media screen and (min-width: 1024px) {
    height: 64px;
    font-size: 24px !important;
    width: 404px !important;
    margin: 70px auto 0 !important;
  }
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    color: #707070;
    font-size: 14px;
    margin: auto 0;
  }

  @media screen and (min-width: 1024px) {
    margin-top: 73px;
    span {
      color: #4e4e4e;
      font-size: 24px;
    }
  }
`;

const Result = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  font-size: 14px;
  font-family: 'dana-bold';
  background-color: #f5f5f5;
  border: ${({ hasResult }) =>
    !hasResult ? '1px solid#ffffff' : '1px solid #3CC0C3'};
  color: ${({ hasResult }) => (!hasResult ? '#707070' : '#6F4D9F')};
  box-shadow: 1px 1px 2px 0px #00000029;
  height: 44px;
  border-radius: 16px;

  span {
    margin-left: 7px;
  }

  @media screen and (min-width: 1024px) {
    height: 64px;
    font-size: 24px !important;
    width: 404px !important;
    margin: 32px auto 100px !important;
    background-color: #ffffff !important;
  }
`;

export { EGFR };
